// extracted by mini-css-extract-plugin
module.exports = {"carouselStack":"LandingClient_carouselStack__Zj5EZ"};